import { FC } from 'react';
import { TouchableOpacity } from 'react-native';
import { SvgProps } from 'react-native-svg';
import { DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles';

import { Button, ButtonProps, isDeviceMinimumSize } from '@pletly/ui';

interface Props extends Omit<ButtonProps, 'children'> {
	Icon: FC<SvgProps>;
	label: string;
}

export const ActionButton = ({ onPress, Icon, label, ...buttonProps }: Props) => {
	const deviceSize = useDeviceSize();
	const isMinWidth = isDeviceMinimumSize(deviceSize, DEVICE_SIZES.MEDIUM_DEVICE);

	if (isMinWidth) {
		return (
			<Button color="primary" variant="filled" size="small" onPress={onPress} {...buttonProps}>
				{label}
			</Button>
		);
	}

	return (
		<TouchableOpacity onPress={onPress}>
			<Icon />
		</TouchableOpacity>
	);
};
